<template>
  <div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-illustration">
        <img src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZXAzbXgwdzdzMmUxbXg4dzJkOWoyc2pxZjJkY3k3M2RieTZrNXhzOCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/5642dlA3QTGtYdAds4/giphy.webp" width="350px" alt="Illustration">
      </div>
      
      <div class="auth-form-section">
        <div class="auth-brand">
          <router-link to="/">天狗商城</router-link>
        </div>
        <h2 class="auth-title">重置密码</h2>
        <p class="auth-subtitle">请输入您的新密码</p>
        <div class="auth-form">
          <div class="input-group">
            <label>新密码</label>
            <input type="password" v-model="passwords.newPassword" placeholder="以大写字母开头, 6-10位" />
          </div>
          <div class="input-group">
            <label>确认新密码</label>
            <input type="password" v-model="passwords.confirmPassword" placeholder="请再次输入新密码" />
          </div>
          <button @click="handleReset" class="auth-button" :disabled="isLoading">
            {{ isLoading ? '正在提交...' : '确认重置' }}
          </button>
          <p class="switch-auth"><router-link to="/login">返回登录</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const passwords = reactive({ newPassword: '', confirmPassword: '' });
const isLoading = ref(false);
const token = ref('');
const router = useRouter();
const route = useRoute();
const { appContext } = getCurrentInstance();
const $axios = appContext.config.globalProperties.$axios;
const $notify = appContext.config.globalProperties.$notify;

onMounted(() => {
    token.value = route.query.token;
    if (!token.value) {
        $notify.add('无效的重置链接', 'error');
        router.push('/login');
    }
});

const handleReset = async () => {
    if (passwords.newPassword !== passwords.confirmPassword) {
        $notify.add('两次输入的密码不一致', 'error');
        return;
    }
    if (!/^[A-Z][a-zA-Z0-9]{5,9}$/.test(passwords.newPassword)) {
        $notify.add('新密码格式不正确', 'error');
        return;
    }

    isLoading.value = true;
    try {
        await $axios.post('/users/forgot-password/reset', {
            token: token.value,
            newPassword: passwords.newPassword
        });
        $notify.add('密码重置成功！请使用新密码登录。', 'success');
        router.push('/login');
    } catch (error) {
        $notify.add(error.response?.data?.msg || '重置失败', 'error');
    } finally {
        isLoading.value = false;
    }
};
</script>

<style scoped>
/* 【核心修改】此处完整复制了 LoginPage.vue 的样式 */
:root {
  --primary-color: #6f42c1;
  --primary-color-dark: #5a3d9a;
  --input-bg-color: #f8f9fa;
}
.auth-page-container { 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  padding: 40px 15px;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  min-height: 100vh;
}
@keyframes gradientBG {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
.auth-card { 
  display: flex;
  width: 100%; 
  max-width: 960px;
  background: #fff; 
  border-radius: 20px; 
  box-shadow: 0 15px 50px rgba(0,0,0,0.15);
  overflow: hidden;
}
.auth-illustration {
  flex: 1;
  background-color: #fbfaff;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-illustration img {
  max-width: 100%;
  animation: floatImage 4s ease-in-out infinite;
}
@keyframes floatImage {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
}
.auth-form-section {
  flex: 1;
  padding: 50px;
}
.auth-brand { text-align: center; margin-bottom: 20px; }
.auth-brand a { color: var(--primary-color); font-size: 2em; font-weight: 700; text-decoration: none; }
.auth-title { text-align: center; font-size: 2em; font-weight: 600; margin: 0 0 10px; }
.auth-subtitle { text-align: center; color: #888; margin-bottom: 30px; }
.input-group { margin-bottom: 20px; text-align: left; }
.input-group label { display: block; margin-bottom: 8px; font-weight: 500; }
.input-group input { width: 100%; box-sizing: border-box; padding: 14px; border-radius: 8px; border: 1px solid #dee2e6; background-color: var(--input-bg-color); font-size: 1em; }
.auth-button { width: 100%; padding: 15px; border: none; background-color: var(--primary-color); color: rgb(97, 92, 92); border-radius: 8px; cursor: pointer; font-size: 1.1em; font-weight: 500; transition: all 0.3s; }
.auth-button:disabled { background-color: #ccc; }
.auth-button:hover { background-color: var(--primary-color-dark); }
.switch-auth { margin-top: 30px; font-size: 14px; text-align: center; color: #888; }
.switch-auth a { color: var(--primary-color); text-decoration: none; font-weight: 500; }
@media (max-width: 900px) {
  .auth-illustration { display: none; }
  .auth-card { max-width: 480px; }
}
</style>